const locale = {
	TAB_INVOICES_DEADLINES: 'Deadlines',
	TAB_INVOICES_DEADLINES_CALENDAR: 'Deadlines calendar',

	VIEW_ITEM_BUTTON_NEW_INVOICE: 'Add Invoice',

	DIALOG_TITLE_INVOICES_MODULE_ADD_TITLE: 'Add Invoice',
	DIALOG_TITLE_INVOICES_MODULE_EDIT_TITLE: 'Edit linked Invoice',

	// #region Invoices fields
	DETAILS_INVOICES_FIELD_TITLE: 'Number',
	DETAILS_INVOICES_FIELD_STATUS: 'Invoice Status',
	DETAILS_INVOICES_FIELD_TYPE: 'Invoice Type',
	DETAILS_INVOICES_FIELD_COMPANY: 'Company',
	DETAILS_INVOICES_FIELD_ASSIGNED_USER: 'Assigned User',
	DETAILS_INVOICES_FIELD_DATE_ISSUE: 'Issue date',
	// DETAILS_INVOICES_FIELD_DATE_EXPIRATION: 'Expiration date',
	// DETAILS_INVOICES_FIELD_DATE_PAYMENT: 'Payment date',
	DETAILS_INVOICES_FIELD_AMOUNT_RESIDUAL: 'Total residual amount (tax excluded)',
	DETAILS_INVOICES_FIELD_AMOUNT_FINAL_TAX_EXCL: 'Total billed amount (tax excluded)',
	DETAILS_INVOICES_FIELD_AMOUNT_FINAL_TAX_INCL: 'Total billed amount (tax included)',
	DETAILS_INVOICES_FIELD_PAYMENTMETHOD: 'Payment method',
	DETAILS_INVOICES_FIELD_PAYMENTTERMS: 'Payment terms',
	DETAILS_INVOICES_FIELD_INTERNALNUMBER: 'Internal number',

	DETAILS_INVOICES_FIELD_HAS_AMOUNT_RESIDUAL: 'Has residual amount',

	DETAILS_INVOICES_OPTION_NEW_INVOICE: 'Create new Invoice',
	DETAILS_INVOICES_OPTION_LINK_INVOICE: 'Link existing Invoice',
	// #endregion

	// #region Invoices Rows section
	INVOICES_ROWS_SECTION_TITLE: 'Invoices rows',

	INVOICES_ROWS_COLUMN_DESCRIPTION: 'Notes',
	INVOICES_ROWS_COLUMN_TABLE: 'Linked Document type',
	INVOICES_ROWS_COLUMN_TABLE_TITLE: 'Linked Document',
	INVOICES_ROWS_COLUMN_TABLE_LINE_TITLE: 'Linked Document Row',
	INVOICES_ROWS_COLUMN_AMOUNT: 'Amount (tax excluded)',

	INVOICES_ROWS_SECTION_TOT_ROWS_AMOUNT: 'Total rows amount (tax excluded): {value}',
	INVOICES_ROWS_SECTION_TOT_INVOICE_AMOUNT_RESIDUAL: 'Total residual amount (tax excluded): {value}',
	// #endregion

	// #region Invoices Deadlines section
	INVOICES_DEADLINES_SECTION_TITLE: 'Invoices Deadlines',

	INVOICES_DEADLINES_COLUMN_INVOICE_TITLE: 'Invoice number',
	INVOICES_DEADLINES_COLUMN_COMPANY: 'Company',
	INVOICES_DEADLINES_COLUMN_DATE_DEADLINE: 'Deadline date',
	INVOICES_DEADLINES_COLUMN_DATE_PAYMENT: 'Payment date',
	INVOICES_DEADLINES_COLUMN_AMOUNT: 'Amount',
	INVOICES_DEADLINES_COLUMN_AMOUNT_PAYMENT: 'Payed amount',
	INVOICES_DEADLINES_COLUMN_PAYMENT_TYPE: 'Payment type',
	INVOICES_DEADLINES_COLUMN_SUBTYPE: 'Subtype',
	INVOICES_DEADLINES_COLUMN_FORCE_CLOSE: 'Forced closure',
	INVOICES_DEADLINES_COLUMN_CLOSED: 'Closed',
	INVOICES_DEADLINES_COLUMN_NOTES: 'Notes',

	INVOICES_DEADLINES_SECTION_TOT_AMOUNT_DEADLINE_RESIDUAL: 'Total residual amount: {value}'
	// #endregion
};

export default locale;
